import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { SubjectsTimepointsParams } from '../types/index'
import { SubjectsTimepointPaginatedSchema } from '@common/config/api/client'

export default function useStudySubjectsTimepointsTableHandlers() {
  const [page, setPage] = useState(0)
  const [isSubjectDialogVisible, setIsSubjectDialogVisible] = useState(false)
  const [isBulkUploadDialogVisible, setIsBulkUploadDialogVisible] = useState(false)
  const [editingSubjectId, setEditingSubjectId] = useState<string | null>(null)
  const { studyId } = useParams<{ studyId: string }>()
  const [subjectsTimepointsParams, setSubjectsTimepointsParams] = useState<SubjectsTimepointsParams>({
    study_id: studyId!,
    search: undefined,
    limit: 50,
    next_cursor: undefined,
    previous_cursor: undefined,
    order_by_field: 'pseudo_id',
    asc_order: true,
  })

  const handleSearch = (value: string) => {
    setSubjectsTimepointsParams((prev) => ({
      ...prev,
      search: value || undefined,
      next_cursor: undefined,
      previous_cursor: undefined,
    }))
    setPage(0)
  }

  const handlePageChange = (
    subjectsList: SubjectsTimepointPaginatedSchema | undefined,
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    const isNextPage = newPage > page
    const cursor = isNextPage ? subjectsList?.pagination.next_cursor : subjectsList?.pagination.previous_cursor

    if (cursor) {
      setSubjectsTimepointsParams((prev) => ({
        ...prev,
        next_cursor: isNextPage ? cursor : null,
        previous_cursor: isNextPage ? null : cursor,
      }))
      setPage(isNextPage ? page + 1 : page - 1)
    }
  }

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSubjectsTimepointsParams((prev) => ({
      ...prev,
      limit: parseInt(event.target.value, 10),
      next_cursor: null,
      previous_cursor: null,
    }))
    setPage(0)
  }

  const handleRequestSort = (_event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = subjectsTimepointsParams.order_by_field === property && subjectsTimepointsParams.asc_order
    setSubjectsTimepointsParams((prev) => ({
      ...prev,
      order_by_field: property,
      asc_order: !isAsc,
      next_cursor: undefined,
      previous_cursor: undefined,
    }))
    setPage(0)
  }

  const handleAddClick = () => {
    setIsSubjectDialogVisible(true)
  }

  const handleEditClick = (subjectId: string) => {
    setEditingSubjectId(subjectId)
    setIsSubjectDialogVisible(true)
  }

  return {
    page,
    isSubjectDialogVisible,
    isBulkUploadDialogVisible,
    editingSubjectId,
    subjectsTimepointsParams,
    setSubjectsTimepointsParams,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleRequestSort,
    handleAddClick,
    handleEditClick,
    setEditingSubjectId,
    setIsSubjectDialogVisible,
    setIsBulkUploadDialogVisible,
  }
}
